/* eslint-disable */
import '../../../../sass/style_baseline/libs/animate.scss';
import 'waypoints/lib/noframework.waypoints.min.js';

const mobileBreakpoint = 768;

export default class waypointTrigger {
    constructor() {
        this.commonElement = document.querySelectorAll("[data-action='waypointTrigger']");
    }

    commonWaypointTrigger() {
        const self = this;
        const commonTrigger = self.commonElement;

        if (commonTrigger) {
            commonTrigger.forEach((element) => {
                new Waypoint({
                    element,
                    handler: () => {
                        const thisElement = element;
                        const duration = 900;

                        thisElement.classList.add('apply-animation');

                        setTimeout(() => {
                            thisElement.classList.remove('pre-animation');
                        }, duration);
                    },
                    offset: (window.innerWidth >= mobileBreakpoint) ? '75%' : '100%',
                });
            });
        }
    }


    init() {
        const self = this;
        self.commonWaypointTrigger();
    }
}

const waypointTriggers = new waypointTrigger();
waypointTriggers.init();
